import React from 'react';
import PropTypes from 'prop-types';

const IndicatorExtrafield = ({ color = '#b5bdc5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M3.06496739,12.1228707 C3.02274118,12.40909 3.00058763,12.7019568 3,13 C2.99935415,13.3405906 3.02729476,13.6746825 3.08158051,14 L2.7,14 C1.20883118,14 0,12.8807119 0,11.5 L0,6.5 C-1.99840144e-16,5.11928813 1.20883118,4 2.7,4 L15.3,4 C16.7911688,4 18,5.11928813 18,6.5 L18,11.5 C18,12.8807119 16.7911688,14 15.3,14 L14.9156778,14 C14.9705041,13.6749025 14.9993559,13.3408359 15.0000001,13 C15.0005897,12.7019529 14.9792867,12.4088822 14.9375931,12.1223131 C15.6074561,11.9759431 16.1,11.4841495 16.1,10.9 L16.1,7.1 C16.1,6.40043932 15.3936048,5.83333333 14.5222222,5.83333333 L3.47777778,5.83333333 C2.60639517,5.83333333 1.9,6.40043932 1.9,7.1 L1.9,10.9 C1.9,11.4848935 2.39379938,11.9771957 3.06496739,12.1228707 Z M9.45665806,13.4422205 L11.5133031,13.4422205 C11.6966999,13.4422205 11.8453724,13.2565214 11.8453724,13.02745 C11.8453724,12.7983787 11.6966999,12.6126796 11.5133031,12.6126796 L9.45665806,12.6126796 L9.45665806,10.51825 C9.45665806,10.335182 9.26868575,10.186776 9.03681015,10.186776 C8.80493456,10.186776 8.61696225,10.335182 8.61696225,10.51825 L8.61696225,12.6126796 L6.53226398,12.6126796 C6.34886719,12.6126796 6.20019471,12.7983787 6.20019471,13.02745 C6.20019471,13.2565214 6.34886719,13.4422205 6.53226398,13.4422205 L8.61696225,13.4422205 L8.61696225,15.4903602 C8.61696225,15.6734283 8.80493456,15.8218343 9.03681015,15.8218343 C9.26868575,15.8218343 9.45665806,15.6734283 9.45665806,15.4903602 L9.45665806,13.4422205 Z M12.5355266,16.5355272 C10.5723733,18.4912741 7.40677649,18.485211 5.46447226,16.5355272 C3.50885112,14.5721793 3.51496371,11.4066019 5.46447226,9.46447283 C7.42789748,7.50877471 10.5936407,7.51488762 12.5355266,9.46447283 C14.4913505,11.4277035 14.4852871,14.5934661 12.5355266,16.5355272 Z"
                id="indicatorextrafield-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/field_extra"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#indicatorextrafield-path-1" />
            </mask>
            <use id="Combined-Shape" fill={color} xlinkHref="#indicatorextrafield-path-1" />
        </g>
    </svg>
);

IndicatorExtrafield.propTypes = {
    color: PropTypes.string,
};

export default IndicatorExtrafield;
